import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { UntypedFormControl, NgForm, ValidationErrors } from '@angular/forms';
import { ApBaseComponent } from '../ap-base-component/index';

@Component({
  selector: 'ap-file-upload',
  templateUrl: './ap-file-upload.component.html',
})
export class ApFileUploadComponent extends ApBaseComponent implements OnInit, OnChanges {
  @Output() filesChanged = new EventEmitter<File[]>();
  @Output() errorOutput = new EventEmitter<string>();

  // Regex of Extensions allowed
  @Input() baseId: string;
  @Input() allowedExtensions: string;
  @Input() fileSizeLimit?: number | null;
  @Input() form?: NgForm;
  @Input() required?: boolean;
  @Input() fileUploadControlDisplayName: string;
  @Input() maxFiles?: number | null;
  @Input() disableChips = true;

  @ViewChild('uploadInput', { static: true }) uploadInput: ElementRef;

  Id: string;
  chips: File[] = [];
  fileUploadControlFormControl: UntypedFormControl;

  constructor() {
    super();
  }

  ngOnInit() {
    this.setId();
    this.initializeFormControl();
  }

  inputUpload() {
    this.uploadInput.nativeElement.click();
  }

  removeFile(file: File) {
    this.chips.splice(this.chips.indexOf(file), 1);
    this.updateFormControl();
    this.filesChanged.emit(this.chips);
  }

  selectFiles(fileUploadEvent: any) {
    const fileList: FileList = fileUploadEvent.target.files;

    /* tslint:disable:prefer-for-of */
    for (let index = 0; index < fileList.length; index++) {
      if (this.allowedExtensions) {
        let extension = '.' + fileList[index].name.split('.').pop();

        if (extension) {
          extension = extension.toLowerCase();
        }

        const matches = extension.match(this.allowedExtensions);
        if (!matches || matches.length < 1) {
          this.errorOutput.emit('File(s) cannot be upload due to file type restriction');
          continue;
        }
      }

      if (this.fileSizeLimit && fileList[index].size > (1000 * this.fileSizeLimit)) {
        this.errorOutput.emit('File size is over the limit of ' + this.fileSizeLimit + ' kb');
        continue;
      }

      if ((this.maxFiles || this.maxFiles === 0) && this.chips.length >= this.maxFiles) {
        this.errorOutput.emit('Maximum number of files uploaded reached (' + this.maxFiles + ')');
        continue;
      }

      this.chips.push(fileList[index]);
      this.errorOutput.emit();
    }

    this.updateFormControl();
    this.filesChanged.emit(this.chips);
  }

  initializeFormControl() {
    if (!this.form) { return; } // if no form is given do not set this up

    this.fileUploadControlFormControl = new UntypedFormControl(null, this.validate.bind(this));
    this.form.form.addControl(this.Id, this.fileUploadControlFormControl);
    this.updateFormControl();
  }

  private updateFormControl() {
    if (!this.fileUploadControlFormControl) { return; }
    this.fileUploadControlFormControl.setValue(this.validate());
  }

  validate(): ValidationErrors | null {
    const valid = this.getIsValid();
    return valid ? null : {
      required: true,
    };
  }

  private getIsValid(): boolean {
    const isValid = !this.required || !!(this.chips && this.chips.length);
    return isValid;
  }

  isRequired(): boolean {
    return !this.required ? false : this.required;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.baseId && changes.baseId.currentValue) {
      this.baseId = changes.baseId.currentValue;
      this.setId();
    }

    if (changes.required && changes.required.currentValue !== undefined) {
      this.required = changes.required.currentValue;
      this.updateFormControl();
    }
  }

  private setId() {
    this.Id = `${this.baseId}-fileupload`;
  }
}
